var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/","id":"header"}},[_c('div',{attrs:{"id":"logo"}}),_c('div',{staticClass:"line"}),_c('div',{attrs:{"id":"topic"}})])}
var staticRenderFns = []

export { render, staticRenderFns }